<div class="surveys-container">
	<div class="header">
		<div class="title">
			<h1>My Questionnaires</h1>
			<div class="subtitle">View and complete your assigned questionnaires</div>
		</div>
	</div>

	<div class="surveys-list">
		@for (survey of respondentSurveys(); track survey) {
			<mat-card class="survey-card">
				<div class="card-content">
					<div class="card-meta-row">
						<div class="survey-info">
							<h2 class="survey-name">{{ survey.survey_name }}</h2>
							@if (survey.survey_description) {
								<p class="survey-description">
									{{ survey.survey_description }}
								</p>
							}
						</div>
						<div class="status-col">
							<mat-chip [color]="getStatusColor(survey.status)" selected>
								{{ getStatusText(survey.status) }}
							</mat-chip>
							@if (survey.completed_at) {
								<span class="completed-at">
									{{
										formatDate(survey.completed_at)
											| date: "MMM d, y 'at' h:mm a"
									}}
								</span>
							}
						</div>
					</div>
					<div class="progress-container">
						<div class="progress-label">
							<span>Progress: {{ survey.progress }}%</span>
							<span
								>{{ survey.answered_count }} of
								{{ survey.question_count }} questions</span
							>
						</div>
						<mat-progress-bar
							[color]="getStatusColor(survey.status)"
							mode="determinate"
							[value]="survey.progress"
						></mat-progress-bar>
					</div>
					<div class="action-button-container">
						<button
							mat-raised-button
							color="primary"
							class="start-button"
							[routerLink]="[
								'/surveys',
								survey.organization_survey_id,
								survey.user_id,
							]"
						>
							@if (survey.progress > 0 && survey.progress < 100) {
								<span>Continue Questionnaire</span>
							}
							@if (survey.progress === 0) {
								<span>Start Questionnaire</span>
							}
							@if (survey.progress === 100) {
								<span>Review Questionnaire</span>
							}
						</button>
					</div>
				</div>
			</mat-card>
		}
	</div>

	@if (respondentSurveys().length === 0 && !loading()) {
		<div class="grid-container">
			<div class="no-data">
				<mat-icon>assignment</mat-icon>
				<p>No questionnaires assigned to you</p>
				<p class="secondary-text">
					Contact your organization administrator if you believe this is an error
				</p>
			</div>
		</div>
	}

	@if (loading()) {
		<div class="loading">
			<mat-spinner diameter="40"></mat-spinner>
		</div>
	}
</div>
